import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { SendMessageInput } from '@/modules/tryIt/components/SendMessageInput/SendMessageInput';
import { isKeyEnter } from '@/util/util';

import { useTestSend } from '../../hooks/useTestSend';
import { selectIsInputDisabled, selectIsReplay } from '../../redux/selectors';

export const Composer = () => {
  const { t } = useTranslation();
  const isReplay = useSelector(selectIsReplay);
  const isInputDisabled = useSelector(selectIsInputDisabled);
  const { send } = useTestSend();

  const handleSend = useCallback(
    (value: string) => {
      if (!value) {
        return;
      }
      void send(value);
    },
    [send]
  );

  const handleButtonClick = useCallback(
    (_: React.MouseEvent<HTMLButtonElement>, value: string) => {
      handleSend(value);
    },
    [handleSend]
  );

  const handleKeyUp = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (isInputDisabled) {
        return;
      }
      const target = e.target as HTMLTextAreaElement;
      if (isKeyEnter(e) && !e.shiftKey && target.value) {
        handleSend(target.value);
      }
    },
    [isInputDisabled, handleSend]
  );

  if (isReplay) {
    return null;
  }

  return (
    <footer className="flex flex-col gap-2 self-stretch pt-2 pr-3 pb-4 pl-3">
      <SendMessageInput
        onKeyUp={handleKeyUp}
        placeholder={t('try_it.composer_placeholder')}
        disabled={isInputDisabled}
        handleButtonClick={handleButtonClick}
        className="max-h-50 justify-end self-stretch border-input pt-4 pr-4 pb-3 pl-4 shadow-xs"
      />
    </footer>
  );
};
